import styled from '@emotion/styled'
import { wrap as withStyle, themeColor } from 'utils/styles'
import Modal from 'components/patterns/Modal'
import SearchInput from 'components/patterns/Inputs/SearchInputV2'
import Icon from 'components/patterns/Icon'

export const StyledModalContent = styled.div``

export const StyledCustomSwitchGraphicsModal = styled(Modal)`
  &&& {
    .ant-modal-body {
      padding-right: 12px;
      height: 550px;
      overflow: auto;
    }

    .ant-modal-header {
      border-bottom: 1px solid ${themeColor('modalBorderColor')};
      & h1 {
        font-weight: bold;
        margin: 0;
      }
    }

    .ant-modal-title {
      display: block;
    }

    .ant-modal-footer {
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid ${themeColor('modalBorderColor')};
    }
  }
`

export default withStyle(
  () => `
    .ant-modal-body {
      padding: 0px !important;
    }
  `
)

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const SearchLabel = styled.div`
  margin-bottom: 4px;

  h3,
  span {
    display: inline;
  }
`

export const SearchInputField = styled(SearchInput)`
  width: 500px;
`

export const TableContainer = styled.div`
  margin-top: 20px;

  &&& .ant-table tr:hover td {
    background: ${themeColor('blueAvailable')};
  }
`
export const ErrorIcon = styled(Icon)`
  margin-right: 15px;
  &&& {
    height: 20px;
    width: 22px;
  }
`
export const HeaderContainer = styled.div`
  align-items: start;
  display: flex;
  flex-direction: row;
`

export const CancelIcon = styled(Icon)`
  cursor: pointer;
  margin-left: auto;
  align-self: center;
  &&& {
    height: 18px;
    width: 20px;
  }
`

export const RadioButtonContainer = styled.div`
  text-align: center;
  height: 24px;
`
